import React from 'react';

const defaultColors = ['green', 'rgb(255, 255, 0)', '#f06d06', 'red'];

function HeatMapLegendComponent() {
  const gradientStyle = { backgroundImage: `linear-gradient(to right, ${defaultColors[0]}, ${defaultColors[1]}, ${defaultColors[2]}, ${defaultColors[3]})` };

  return (
    <div className="i2p2-heatmap">
      <div className="gradient">
        <p className="density">Chargers density</p>
        <div
          className="gradient-line"
          style={gradientStyle}
        />
        <span className="left">low</span>
        <span className="right">high</span>
      </div>
    </div>
  );
}

export default HeatMapLegendComponent;
